import { AirtableTable } from "@/types/crm/airtable/common";
import { ApiErrors, NotFoundError } from "@/types/crm/airtable/errors";



export async function getTables({ baseId, apiKey }: { baseId: string, apiKey: string }): Promise<
| { tables: AirtableTable[], error: { type: ApiErrors, message: string } | NotFoundError } 
// | { error: NotFoundError } 
// | { error:  { type: ApiErrors, message: string }}
> {
    const res = await fetch(`https://api.airtable.com/v0/meta/bases/${baseId}/tables`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${apiKey}`
        }
    })
        .then(res => res.json())
    if (res.error) {
        console.log(res.error)
        if (typeof res.error === 'string')
            throw new Error(res.error)
        throw new Error(res.error.type)
    }
    return res
}

export async function getTable({ baseId, apiKey, tableNameOrId }: { baseId: string, apiKey: string, tableNameOrId: string }): Promise<AirtableTable | undefined> {
    const res = await getTables({ baseId, apiKey });
    if(res?.error) {
        if(typeof res.error === 'string')
            throw new Error(res.error)
        throw new Error(res.error.type)
    }
    const table = res.tables.find((t: { name: string, id: string }) => t.name === tableNameOrId || t.id === tableNameOrId)
    return table
}

